module.exports = __webpack_public_path__ + "static/media/book2.e6fe8587.jpg";